import repository from "@/repo/repository.service";
import router from "@/routes.js";

// const themeInfo = JSON.parse(localStorage.getItem("themeInfo"));
const initialState = {
  token: null,
  template: null,
  info: null,
  customStyleCss: null,
};

export const theme = {
  namespaced: true,
  state: initialState,
  getters: {
    themeInfo: (state) => {
      return state;
    },
  },
  actions: {
    getAllData({ commit }, { payload }) {
      return new Promise((resolve, reject) => {
        repository
          .postData(`/GetDataWithToken/${payload.token}`, {
            "api-key": "sJ4D*q#dI4J@as7D1(s$",
          })
          .then((res) => {
            let tName = "defualts";
            console.log(
              "---------------------------------------------------------"
            );
            console.log(res);
            console.log(
              "---------------------------------------------------------"
            );
            commit("set", {
              token: payload.token,
              template: res.data.template,
              info: {
                ...res.data,
              },
              // customStyleCss: `
              // html{background: red;}
              // .Xstyle .page-container{background-color: red;}
              // .Xstyle .header-section{background-color:red !important;}

              // .Xstyle .bottom-navigation{background-color: blue !important;}
              // .Xstyle .bottom-navigation .nav-btn{filter: invert(1)}

              // .Xstyle .qr-code-box{background:blue !important;}
              // .Xstyle .qr-code-box-btn{background-color:red !important;}

              // .Xstyle .option-card .img-div{background-color: blue !important; border-color: red !important;}
              // .Xstyle .option-card:hover .img-div{background-color: blue !important;
              //    border-color: red !important;
              //    background-image:unset !important;
              //    box-shadow: calc(-0.3 * var(--sw)) calc(-0.3 * var(--sw)) calc(3 * var(--sw)) rgba(255, 255, 255, 0.5), calc(0 * var(--sw)) calc(1 * var(--sw)) calc(6 * var(--sw)) red !important}

              // .Xstyle .products-list-section .title , .Xstyle .products-banner-section ,.Xstyle .members-banner-section ,.Xstyle .member-list-section .title{background-color:blue;}`,
            });
            resolve(res.data);
          })
          .catch((error) => {
            router.push("/404");
            reject(error);
            console.error(error);
          });
      });
    },
  },
  mutations: {
    set(state, themeInfo) {
      Object.keys(state).forEach((key) => (state[key] = themeInfo[key]));
    },
  },
};
